var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.planing-team-validate.hours_real"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      "loading-primary-footer-button": _vm.isLoading,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "biometric-hour-field" } }, [
                _vm._v(_vm._s(_vm.$t("pages.planing-team-validate.hours"))),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.hourValue,
                    expression: "hourValue",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "biometric-hour-field" },
                domProps: { value: _vm.hourValue },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.hourValue = $event.target.value
                  },
                },
              }),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }